import React from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import IDashboardItem from "../../../models/IDashboardItem";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    inEditor: boolean;
    widget?: IDashboardItem;
    removeWidget?: () => void;
    updateWidgetFn?: (widgetData: any, widgetUuid: string) => void;
};

const WidgetContainer = styled.div`
    padding: 0.5rem;
    justify-content: start !important;
    align-items: start !important;
    height: 100%;

    input {
        width: 100%;
    }

    .position-relative {
        width: 100%;
    }
`;

export const CreateOrderWidget: React.FC<Props> = (props) => {
    return (
        <WidgetContainer className={"CreateOrderWidget widget d-flex align-items-center justify-content-center"}>
            <div className={"d-flex flex-column align-items-center justify-content-center h-100 w-100"}>
                <Link title={"order"} to={"/orders?create=true"}>
                    <OwTitle className={"pointer"} title={"create_new_order"} tag={"h5"} leftIconName={"fas fa-plus"} />
                </Link>
                {props.inEditor ? (
                    <OwIconButton
                        iconClass={"fas fa-trash-alt"}
                        iconColorClass={"text-danger"}
                        fn={() => {
                            props.removeWidget!();
                        }}
                    />
                ) : null}
            </div>
        </WidgetContainer>
    );
};
